import React from 'react';

export function MobilePopupHeader(props) {

  return (
    <div className="mobile-popup__header">
      {props.children}
      <i className="mobile-popup__close icon-close" onClick={props.onClose} />
    </div>
  )
}

export function MobilePopupFooter(props) {

  return (
    <div className="mobile-popup__footer">{props.children}</div>
  )
}

export default function MobilePopup(props) {

  return (
    <div className="mobile-popup">
      {props.children}
    </div>
  )
}